import { GetNewController } from "../factoryController";
import { SingletonEnginnering } from "../singletonEngineering";
import { SingletonFlowchart } from "../singletonFlowchart";
import { defaultSuccess } from "@/global";

const RebuilderNodes = {
  rebuild: function(areas, currentArea) {
    let bkp = {};
    try{
      bkp = JSON.parse(JSON.stringify(areas))

      for (const flow of areas) {
        let nodesChanged = [];

        if(typeof flow.configuration == "string")
          flow.configuration = JSON.parse(flow.configuration);
  
        for (const j in flow.configuration) {
          let jsonNode = flow.configuration[j];
  
          let ctr = GetNewController(jsonNode.type);

          if(!ctr) continue;

          let node = ctr.getNode(jsonNode);
          if(!node) continue;
          
          let newProps = this.getRelatedData(node.data);

          node.rebuildStructure(newProps);
          nodesChanged.push(node.clone());
        }
        flow.configuration = nodesChanged;
  
        if (flow.area == currentArea) {
          SingletonFlowchart.Memory.memory.forEach((n) => {
            let nodeFound = nodesChanged.find((nf) => nf.id == n.id);
  
            if (nodeFound) {
              n.data = nodeFound.data;
            }
          });
        }
        flow.configuration = JSON.stringify(flow.configuration)
      }
      defaultSuccess('Operações atualizadas com sucesso.');
    }
    catch (e)
    {
      areas.length = 0;
      bkp.forEach(a => areas.push(a));
      console.error("Falha realizar o rebuild das operações", e)
    }
  },

  getRelatedData: function(referenceData) {
    let operationList = [];
    let currentList = [];
    let sourceData = [];

    for (const i in referenceData) {
      let refProp = referenceData[i];

      if (refProp.type == "Operações" && !operationList.includes(refProp.index))
        operationList.push(refProp.index);

      if (refProp.type == "Correntes" && !currentList.includes(refProp.index))
        currentList.push(refProp.index);
    }

    for (const j in operationList) {
      let prop = [];
      let equipList = [];
      try {
        prop = SingletonEnginnering.getOperationsProperties(operationList[j]);
        equipList = SingletonEnginnering.getAllEquipmentProperties(
          operationList[j]
        );
      } catch {
        prop = [];
        equipList = [];
      }

      sourceData = [...prop, ...equipList, ...sourceData];
    }

    for (const k in currentList) {
      let prop = SingletonEnginnering.getAllPropertiesInCurrent(currentList[k]);
      sourceData = [...prop, ...sourceData];
    }

    return sourceData;
  },
};

export default RebuilderNodes;
